export default __webpack_public_path__ + "static/media/yoga.60e897de.png";